import { g as getDateFromDatepicker } from './get-date-from-datepicker.js';
import { i as isBookingEnginePage } from './is-booking-engine-page.js';
import './index3.js';
import './index2.js';

/**
 * **Hbook by Hsystems**
 *
 * @exports bs_203
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_203
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {

    const $ = window.jQuery;
    const mobile = window.location.pathname.match('/(B|b)ooking/IndexMobile');

    // Only for the BE
    if (window.location.hostname.slice(-14) !== 'hsystem.com.br') {
      return;
    }

    // Mobile
    if (mobile) {

      thn.hbookMobileObserver = thn.debounce(function () {

        thn.pageCheck();

        if (thn.data.pageName === 'Rooms and Rates' && thn.widgets.price.isSet()) {
          thn.widgets.price.reset();
        }

      }, 500);

      const container = document.querySelector('.steps-container');

      if (container) {
        thn.observeDom(container, thn.hbookMobileObserver, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      }
      // Desktop
    } else {
      const $bread = $('.breadcrumb.book-step');

      if ($bread.length) {
        thn.observeDom($bread.get(0), thn.debounce(function () {
          thn.pageCheck();
        }, 600), {
          childList: true,
          subtree: true,
          characterData: false,
          attributes: true,
          attributeFilter: ['class', 'style'],
        });
      }

    }
  };

  /**
     * @memberOf module:bs_203
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      if (thn.data.accountUserId === 1035415 && !isBookingEnginePage(thn.data.pageName)) {
        resolve('pt');
        return;
      }

      const aux = thn.parseUrlParameter('language');
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      if (window.location.hostname.match(/hbook.hsystem.com.br/)) {
        // If NO "language" parameter in the URL then "pt"
        resolve('pt');
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_203
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const $ = window.jQuery;
    const mobile = window.location.pathname === '/Booking/IndexMobile';

    if (!$ || mobile || thn.hbookPriceObserver) {
      return;
    }

    thn.hbookPriceObserver = thn.debounce(function () {
      if ($('.blockUI:visible').length) {
        thn.data.hbookNewSearch = true;
      } else if (thn.data.hbookNewSearch) {
        thn.data.hbookNewSearch = false;
        if (ctx.widget.refresh() && !ctx.widget.isSet()) {
          ctx.widget.hide();
        }
      }
    }, 600);

    thn.observeDom(document.body, thn.hbookPriceObserver, {
      childList: true,
      subtree: false,
      characterData: false,
    });

    thn.pageUnload(function () {
      thn.stopObserveDom(document.body, thn.hbookPriceObserver);
      delete thn.hbookPriceObserver;
    });

    const $breadcrumbSteps = $('.breadcrumb-steps');
    if ($breadcrumbSteps.length > 0
            && !thn.hbookBreadcrumbObserver) {
      thn.hbookBreadcrumbObserver = thn.debounce(function () {
        thn.pageCheck();
      }, 400);

      thn.observeDom($breadcrumbSteps.get(0), thn.hbookBreadcrumbObserver, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

  };

  /**
     * @memberOf module:bs_203
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    const mobile = window.location.pathname.match('/(B|b)ooking/IndexMobile');

    if (!$) { return widgetData; }

    if (mobile) {
      const $searchFields = $('.edit-search-container span.value');
      if ($searchFields && $searchFields.length === 4) {
        // Dates
        const $dates = $('.edit-search-container span.value:eq(0) strong');
        if ($dates && $dates.length === 2) {
          widgetData.dateBegin = $dates.eq(0).text().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
          widgetData.dateEnd = $dates.eq(1).text().replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        }
        // Guests
        widgetData.adults = thn.parseNumber($searchFields.eq(1).text()) || 2;
        widgetData.children = thn.parseNumber($searchFields.eq(2).text()) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
      }

      // Desktop
    } else {
      // Dates
      widgetData.dateBegin = getDateFromDatepicker('#arrival');
      widgetData.dateEnd = getDateFromDatepicker('#departure');
      // Guests
      widgetData.adults = parseInt($('.adult-container select').val(), 10) || 2;
      widgetData.children = parseInt($('#children-container select').val(), 10) || 0;
      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
    }

    if (widgetData.children) {
      const room1Info = {
        adults: widgetData.adults,
        children: widgetData.children,
        childrenAges: [],
      };
      for (let i = 1; i <= widgetData.children; i += 1) {
        room1Info.childrenAges.push(10);
      }
      widgetData.roomsDispo = [room1Info];
    }

    // Prices (Works for both desktop and mobile)
    const $prices = $('.item-value[data-bind*="formatCurrency"]:visible, .total-value');
    const prices = $prices
      .map((idx, el) => thn.parseNumber($(el).text()))
      .toArray();

    if ($('.room-unavailable:visible').length || !prices) {
      widgetData.noRooms = true;
    } else {
      // price is by_stay
      widgetData.price = Math.min(...prices)
                / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.currency = thn.getCurrencyCode(($prices.eq(0).text().match(/[^\d\s,.]+/) || [])[0]);
      widgetData.set = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_203
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const pw = thn.widgets.price.data;

    // Mobile doesn't show this id
    widgetData.bookingId = thn.parseUrlParameter('bookingId');

    // No booking info in BC page, use PW data
    if (pw) {
      // Dates
      widgetData.dateBegin = pw.dateBegin;
      widgetData.dateEnd = pw.dateEnd;
      // Prices
      widgetData.price = pw.price;
      widgetData.currency = pw.currency;
      widgetData.set = true;
    }

    return widgetData;
  };

  return engine;

}

export { factory };
